import { defineStore } from 'pinia'
import { imageTemplateService } from '@/services/imageTemplateService'

function errorResult(error) {
  if (error.response && error.response.status === 422) {
    return { success: false, errors: error.response.data.errors };
  }

  return { success: false, errors: {} };
}

/* Requisição em andamento, para a página e o modal não buscarem duas vezes. */
let loadingPromise = null;

export const useImageTemplateStore = defineStore('imageTemplate', {
  state: () => ({
    templates: [],
    defaults: { story: null, post: null },
    loaded: false,
  }),

  actions: {
    /* Busca uma vez por sessão; depois as alterações já ficam no store. */
    async getTemplates() {
      if (this.loaded) {
        return;
      }

      if (!loadingPromise) {
        loadingPromise = this.fetchTemplates().finally(() => {
          loadingPromise = null;
        });
      }

      await loadingPromise;
    },

    async fetchTemplates() {
      try {
        const response = await imageTemplateService.fetchTemplates();
        this.templates = response.data.templates;
        this.defaults = response.data.defaults;
        this.loaded = true;
      } catch (error) {
        return;
      }
    },

    async saveTemplate(id, params) {
      try {
        let response;

        if (id) {
          response = await imageTemplateService.updateTemplate(id, params);
        } else {
          response = await imageTemplateService.createTemplate(params);
        }

        const template = response.data.data;
        const index = this.templates.findIndex(item => item.id === template.id);

        if (index >= 0) {
          this.templates[index] = template;
        } else {
          this.templates.push(template);
        }

        return { success: true, template };
      } catch (error) {
        return errorResult(error);
      }
    },

    async deleteTemplate(id) {
      try {
        await imageTemplateService.deleteTemplate(id);
        this.templates = this.templates.filter(item => item.id !== id);

        for (const format in this.defaults) {
          const source = this.defaults[format];

          if (source && source.type === 'saved' && source.id === id) {
            this.defaults[format] = null;
          }
        }

        return { success: true };
      } catch (error) {
        return errorResult(error);
      }
    },

    async setDefault(format, source) {
      try {
        const response = await imageTemplateService.setDefault(format, source);
        this.defaults = response.data;
        return { success: true };
      } catch (error) {
        return errorResult(error);
      }
    },
  }
});
